import styled from "styled-components";

export const OnboardingIconContainerStyled = styled.div`
    height: 48px;
    width: 48px;
    padding: 4px;
    font-size: 26px;
    border-radius: 8px;
    background: var(--color-yellow);
    display: flex;
    justify-content: center;
    align-items: center;
`;
